/* global Sys, Core, Services, Resources, Language, Utils */
Sys.ns("Core");

/**
 * The Reality Check model.
 *
 * @class Core.RealityCheckModel
 * @extends Core.Model
 */
Core.RealityCheckModel = {

    /**
     * @inheritdoc
     */
    constructor: function() {
        Core.RealityCheckModel.superclass.constructor.apply(this, arguments);
    },

    /**
     * Get the dialog config.
     *
     * @param {string} message The message to display.
     * @param {Object} scope The scope to use for the buttons.
     * @param {string} action The action to be done when dialog is closed.
     * @returns {Object} Dialog config.
     */
    getDialog: function(message, scope, action) {
        var homeBtn = {
                scope: scope,
                text: Services.languageManager.getText(Language.Keys.btn_casino),
                action: function() {
                    scope.fireEvent("notify:dialogBoxClosed", { name: "realityCheck", button: "home" });
                    Sys.utils.goToLobby(Utils.CONSTANTS.REASON_CODES.NORMAL_GAME_TERMINATION);
                }
            },
            continueBtn = {
                scope: scope,
                text: Services.languageManager.getText(Language.Keys.btn_continue),
                action: function() {
                    scope.complete(action);
                    scope.fireEvent("notify:dialogBoxClosed", { name: "realityCheck", button: "continue" });
                    scope.sendServerAction("rcreset", "notify:responseParser.rcInfoReset");
                },
                primary: true
            },
            endBtn = {
                scope: scope,
                text: Services.languageManager.getText(Language.Keys.btn_checkEnd),
                action: function() {
                    scope.complete(action);
                    scope.fireEvent("notify:dialogBoxClosed", { name: "realityCheck", button: "end" });
                    scope.fireEvent("request:stopGame.disable");
                }
            };

        return {
            title: Services.languageManager.getText(Language.Keys.rc_checkReminder),
            text: message,
            buttons: Sys.utils.isHomeAvailable() ? [homeBtn, continueBtn] : [endBtn, continueBtn]
        };
    },

    /**
     * @protected
     * @inheritdoc
     */
    setupData: function() {
        this.processInitData(Resources.readData("gameServerInitResponse"));
    },

    /**
     * Processes the data from server to setup the Reality Check.
     *
     * @param {Object} initResponse The server data of the init response.
     * @returns {void}
     */
    processInitData: function(initResponse) {
        // make sure param is true by also checking string for true
        var rcEnabled = Sys.utils.strIsTrue(initResponse["rc.enabled"]);

        // Reality check should not be enabled during freerounds
        if (Sys.utils.toInt(initResponse.freeRoundsLeft) > 0) {
            rcEnabled = false;
        }

        this.storeData("rcEnabled", rcEnabled);

        // If reality check should be enabled, store timeout parameter
        if (rcEnabled) {
            // If timeout is defined store it, else log error and deactivate reality check
            if (Sys.isDefined(initResponse["rc.msuntiltimeout"])) {
                this.storeData("msUntilTimeout", Sys.utils.toInt(initResponse["rc.msuntiltimeout"]));
                this.storeData("lastCheckTime", Date.now());
            }
            else {
                this.storeData("rcEnabled", false);
            }
        }
    },

    /**
     * Store relevant parts of the server response (the next server action).
     *
     * @param {Object} serverResponse The server response.
     * @returns {void}
     */
    processServerResponse: function(serverResponse) {
        this.storeData("nextAction", serverResponse.nextaction);
    },

    /**
     * Makes a check if it's time for reality check.
     *
     * @returns {boolean} If it's time to do a reality check.
     */
    isTimeToDoRealityCheck: function() {
        var realityCheckDue;

        if (this.readData("rcEnabled")) {
            realityCheckDue = this.readData("lastCheckTime") + this.readData("msUntilTimeout") <= Date.now();
            if (this.readData("nextAction") === "spin" && realityCheckDue) {
                return true;
            }
        }

        return false;
    }
};

Core.RealityCheckModel = Sys.extend(Core.Model, Core.RealityCheckModel, "Core.RealityCheckModel");
